export const RECORDING_PAGE_SIZE = 10;

export const EVENT_PAGE_SIZE = 10;
